export default __webpack_public_path__ + "static/media/delivery-any-time.86ae53e9.png";